<template>
  <header
    role="banner"
    :class="['header-container', { z10000: isTagSearchLayerOpen }]"
  >
    <w-tag-search-layer
      v-if="isTagSearchLayerOpen"
      id="searchPop"
      :search-page-type="searchPageType"
      :close-search-popup="closeTagSearchLayer"
    />
    <alarm-popup />
    <w-wavveon-menu v-if="isWavveOn" />
    <nav class="navbar-container">
      <div class="navbar-content">
        <w-header-logo :is-wavve-on="isWavveOn" class="logo" />
        <w-category-list v-if="!isLogoOnly" class="category" />
        <w-header-menu
          v-if="!isLogoOnly"
          :is-wavve-on="isWavveOn"
          :show-search="!isTagSearchLayerOpen"
        />
      </div>
    </nav>
  </header>
</template>

<script setup>
  import WHeaderLogo from '@/components/header/WHeaderLogo'
  import WCategoryList from '@/components/header/WCategoryList'
  import WHeaderMenu from '@/components/header/WHeaderMenu'
  import WWavveonMenu from '@/components/header/WWavveonMenu'
  import WTagSearchLayer from '@/components/search/view/SearchPopup'
  import AlarmPopup from '@/components/common/header/AlarmPopupWrapper'
</script>

<script>
  import { sendEventLogCloseTagSearchPopup } from '@/common/utils/log.v2.send'
  import { setDisableScrolling } from '@/common/utils/common'
  import { SEARCH_HEADER_TAG_LAYER } from '@/common/resources/const'
  import cookie from '@/common/utils/cookie'

  export default {
    name: 'WHeader',
    props: {
      isLogoOnly: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isTagSearchLayerOpen: false,
        searchPageType: 'broadcast',
      }
    },
    computed: {
      isWavveOn() {
        return cookie.isWavveOn()
      },
    },
    watch: {
      $route(route) {
        const isSearch = route.path === '/search'
        if (!isSearch && this.isTagSearchLayerOpen) {
          this.closeTagSearchLayer()
        }
      },
    },
    beforeDestroy() {
      delete window.showTagSearchLayout
      this.$events.$off('showSearchPopupTag')
    },
    created() {
      this.$events.$on('showSearchPopupTag', (value) => {
        this.openTagSearchLayer(value)
      })
      window.showTagSearchLayout = (type) => {
        let tempType = type
        if (type === 'movie') tempType = 'reTagDetail_movie'
        this.showSearchPopup(tempType)
      }
    },
    methods: {
      openTagSearchLayer(type) {
        if (typeof window.setInputShow === 'function') {
          window.setInputShow(false)
        }
        this.searchPageType = type
        this.isTagSearchLayerOpen = true
        this.$events.$emit(SEARCH_HEADER_TAG_LAYER, { isTagLayerOpen: true })
        setDisableScrolling(true) // 윈도우 스크롤 방지
        if (window.playerInstance) window.playerInstance.clearEvent() // 플레이어 키 이벤트 비활성화
      },
      closeTagSearchLayer() {
        this.isTagSearchLayerOpen = false
        sendEventLogCloseTagSearchPopup({ type: this.searchPageType })
        setDisableScrolling(false) // 윈도우 스크롤 사용
        if (window.playerInstance) window.playerInstance.setupEvent() // 플레이어 키 이벤트 활성화
      },
    },
  }
</script>

<style lang="scss" scoped>
  .header-container {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 1750;
    min-width: 1440px;
    background-color: #1b1b1b;
    &.z10000 {
      z-index: 10000;
    }
    .navbar {
      &-container {
        width: 100%;
        height: 74px;
      }
      &-content {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: 0 100px;
        .logo {
          margin-right: 78px;
        }
        .category {
          flex: 1;
        }
      }
    }
  }
</style>
